exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.instructions-text[data-v-1fd6cffa],\n.instructions-text a[data-v-1fd6cffa] {\n  font-size: 12px;\n}\n.title-text[data-v-1fd6cffa] {\n  font-size: 12px;\n  font-weight: 600;\n  padding-bottom: 8px;\n  text-transform: uppercase;\n  color: #616161;\n}\n.deleteBtn[data-v-1fd6cffa] {\n  height: 42px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fd6cffa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/Mailing/SmtpServers.vue
// module id = O+wb
// module chunks = 0